import { render } from "./Whatsapp.vue?vue&type=template&id=09bffcf0"
import script from "./Whatsapp.vue?vue&type=script&lang=js"
export * from "./Whatsapp.vue?vue&type=script&lang=js"

import "./Whatsapp.vue?vue&type=style&index=0&id=09bffcf0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__